module.exports = __webpack_public_path__ + "static/media/ginny-sparkle.40c51650.webp";